import { forwardRef } from 'react';

import { useRecoilValue } from 'recoil';

import {
  usePaymentContext,
  usePaymentContextApi
} from 'components/Payments/NewPayment/PaymentContent/context/PaymentContext';
import { currentPractice } from 'components/practice/practiceState';
import SegmentedControl from 'components/shared/SegmentedControl/SegmentedControl';

import {
  DEFAULT_INSTALLMENTS_PAYMENT,
  DEFAULT_RECURRING_PAYMENT,
  PLAN_TYPE_OPTIONS
} from '../../lib/helpers';

import AutoRecurring from './components/AutoRecurring/AutoRecurring';
import Installments from './components/Installments';

const PLAN_TYPE_COMPONENTS = {
  'auto-recurring': AutoRecurring,
  installments: Installments
};

const RecurringDetails = forwardRef(({ caps } = {}, ref) => {
  const practice = useRecoilValue(currentPractice);
  const { values } = usePaymentContext();
  const { setFieldValue } = usePaymentContextApi();

  const handlePlanTypeChange = (item) => {
    const currentRecurringPayment =
      item.value === 'auto-recurring'
        ? DEFAULT_RECURRING_PAYMENT(practice?.timezone)
        : DEFAULT_INSTALLMENTS_PAYMENT(practice?.timezone);
    setFieldValue('recurringPayment', currentRecurringPayment);
  };

  const PlanTypeComponent = PLAN_TYPE_COMPONENTS[values?.recurringPayment?.type];

  if (!PlanTypeComponent) return null;

  const planTypeProps = PlanTypeComponent === Installments ? { caps } : {};

  return (
    <div className="flex flex-col gap-4" ref={ref}>
      {!caps?.lockType && (
        <SegmentedControl
          active={values.recurringPayment.type}
          items={PLAN_TYPE_OPTIONS}
          onClick={handlePlanTypeChange}
        />
      )}
      {PlanTypeComponent && <PlanTypeComponent {...planTypeProps} />}
    </div>
  );
});

export default RecurringDetails;
